var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 107",
    d: "M9.719 7.004l-5.743 5.743"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108",
    d: "M9.719 7.004L3.976 1.261"
  }))));
}

export default SvgNavChevron;